import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0285efcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-recap-topbar"
}
const _hoisted_2 = { class: "nge-recap-content" }
const _hoisted_3 = { class: "nge-recap-hero" }
const _hoisted_4 = { class: "nge-recap-hero-title" }
const _hoisted_5 = { class: "nge-recap-hero-daterange" }
const _hoisted_6 = { class: "nge-recap-big-stat" }
const _hoisted_7 = { class: "nge-recap-big-number" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-big-label" }, "edits this week", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-recap-big-sub" }
const _hoisted_10 = {
  key: 0,
  class: "nge-recap-section nge-recap-streak"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Editing Streak", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-recap-streak-row" }
const _hoisted_13 = { class: "nge-recap-streak-current" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-recap-flame" }, "🔥", -1 /* HOISTED */))
const _hoisted_15 = { class: "nge-recap-streak-num" }
const _hoisted_16 = { class: "nge-recap-streak-unit" }
const _hoisted_17 = {
  key: 0,
  class: "nge-recap-streak-record"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-recap-streak-record-label" }, "Personal best:", -1 /* HOISTED */))
const _hoisted_19 = { class: "nge-recap-streak-record-num" }
const _hoisted_20 = { class: "nge-recap-streak-unit" }
const _hoisted_21 = { class: "nge-recap-section nge-recap-month" }
const _hoisted_22 = { class: "nge-recap-section-label" }
const _hoisted_23 = { class: "nge-recap-month-grid" }
const _hoisted_24 = { class: "nge-recap-month-cell" }
const _hoisted_25 = { class: "nge-recap-month-num" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "total edits", -1 /* HOISTED */))
const _hoisted_27 = { class: "nge-recap-month-cell" }
const _hoisted_28 = { class: "nge-recap-month-num" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "merges", -1 /* HOISTED */))
const _hoisted_30 = { class: "nge-recap-month-cell" }
const _hoisted_31 = { class: "nge-recap-month-num" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "splits", -1 /* HOISTED */))
const _hoisted_33 = {
  key: 1,
  class: "nge-recap-section nge-recap-cells"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Cell Activity", -1 /* HOISTED */))
const _hoisted_35 = { class: "nge-recap-month-grid" }
const _hoisted_36 = { class: "nge-recap-month-cell" }
const _hoisted_37 = { class: "nge-recap-month-num nge-recap-cells-complete" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "completed", -1 /* HOISTED */))
const _hoisted_39 = { class: "nge-recap-month-cell" }
const _hoisted_40 = { class: "nge-recap-month-num nge-recap-cells-id" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "identified", -1 /* HOISTED */))
const _hoisted_42 = { class: "nge-recap-month-cell" }
const _hoisted_43 = { class: "nge-recap-month-num" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "touched", -1 /* HOISTED */))
const _hoisted_45 = {
  key: 0,
  class: "nge-recap-cell-list"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "nge-recap-cell-name" }
const _hoisted_48 = {
  key: 0,
  class: "nge-recap-cell-type"
}
const _hoisted_49 = { class: "nge-recap-section" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Scout Report", -1 /* HOISTED */))
const _hoisted_51 = { class: "nge-recap-month-grid" }
const _hoisted_52 = { class: "nge-recap-month-cell" }
const _hoisted_53 = {
  class: "nge-recap-month-num",
  style: {"color":"#35b5ff"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "tags placed", -1 /* HOISTED */))
const _hoisted_55 = { class: "nge-recap-month-cell" }
const _hoisted_56 = {
  class: "nge-recap-month-num",
  style: {"color":"#9d9"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "tags you fixed", -1 /* HOISTED */))
const _hoisted_58 = { class: "nge-recap-month-cell" }
const _hoisted_59 = { class: "nge-recap-month-num" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "help asked", -1 /* HOISTED */))
const _hoisted_61 = { class: "nge-recap-month-cell" }
const _hoisted_62 = {
  class: "nge-recap-month-num",
  style: {"color":"#7f8"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-month-key" }, "help answered", -1 /* HOISTED */))
const _hoisted_64 = {
  key: 2,
  class: "nge-recap-section nge-recap-community"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Community This Week", -1 /* HOISTED */))
const _hoisted_66 = { class: "nge-recap-community-total" }
const _hoisted_67 = {
  key: 0,
  class: "nge-recap-community-share"
}
const _hoisted_68 = {
  key: 3,
  class: "nge-recap-section nge-recap-badge-progress"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Next Badge", -1 /* HOISTED */))
const _hoisted_70 = { class: "nge-recap-badge-row" }
const _hoisted_71 = { class: "nge-recap-badge-name" }
const _hoisted_72 = { class: "nge-recap-badge-remaining" }
const _hoisted_73 = { class: "nge-recap-progress-track" }
const _hoisted_74 = { class: "nge-recap-progress-labels" }
const _hoisted_75 = {
  key: 4,
  class: "nge-recap-section nge-recap-badge-complete"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-section-label" }, "Badges", -1 /* HOISTED */))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-all-done" }, "All badges unlocked. You are a Legend. 🏆", -1 /* HOISTED */))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = { class: "nge-recap-section nge-recap-fact" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-recap-fact-eyebrow" }, "Did you know?", -1 /* HOISTED */))
const _hoisted_81 = { class: "nge-recap-fact-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.embedded ? 'div' : $setup.ModalOverlay), {
    id: $setup.props.embedded ? undefined : 'nge-recap-modal',
    class: _normalizeClass($setup.props.embedded ? 'nge-recap-embedded' : 'nge-recap-modal'),
    onHide: _cache[1] || (_cache[1] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["nge-recap-shell", { 'nge-recap-shell--embedded': $setup.props.embedded }])
      }, [
        _createCommentVNode(" Non-scrolling topbar (modal only) "),
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "nge-recap-exit",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Scrollable content "),
        _createElementVNode("div", _hoisted_2, [
          _createCommentVNode(" Hero header "),
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" \"My\" when shown inside your own profile, \"Your\" when it appears\n               as a standalone toast/panel addressed to the reader. "),
            _createElementVNode("div", _hoisted_4, _toDisplayString($props.embedded ? 'My' : 'Your') + " Week in Science", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.weekRange), 1 /* TEXT */)
          ]),
          _createCommentVNode(" Big hero edit number "),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString($setup.stats.editsThisWeek.toLocaleString()), 1 /* TEXT */),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.stats.mergesThisWeek.toLocaleString()) + " merges + " + _toDisplayString($setup.stats.splitsThisWeek.toLocaleString()) + " splits ", 1 /* TEXT */)
          ]),
          _createCommentVNode(" Streak showcase "),
          ($setup.stats.currentStreak > 0 || $setup.stats.longestStreak > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString($setup.stats.currentStreak), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_16, " day" + _toDisplayString($setup.stats.currentStreak === 1 ? '' : 's') + " in a row ", 1 /* TEXT */)
                  ]),
                  ($setup.stats.longestStreak > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("span", _hoisted_19, _toDisplayString($setup.stats.longestStreak), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_20, " day" + _toDisplayString($setup.stats.longestStreak === 1 ? '' : 's'), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Month summary "),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString($setup.monthLabel), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString($setup.stats.editsThisMonth.toLocaleString()), 1 /* TEXT */),
                _hoisted_26
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString($setup.stats.mergesThisMonth.toLocaleString()), 1 /* TEXT */),
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString($setup.stats.splitsThisMonth.toLocaleString()), 1 /* TEXT */),
                _hoisted_32
              ])
            ])
          ]),
          _createCommentVNode(" Cell activity this week "),
          ($setup.cellsThisWeek.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString($setup.cellsCompleted.length), 1 /* TEXT */),
                    _hoisted_38
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString($setup.cellsIdentified.length), 1 /* TEXT */),
                    _hoisted_41
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, _toDisplayString($setup.cellsThisWeek.length), 1 /* TEXT */),
                    _hoisted_44
                  ])
                ]),
                ($setup.cellsThisWeek.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cellsThisWeek.slice(0, 8), (cell) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: cell.segId,
                          class: "nge-recap-cell-row",
                          onClick: $event => ($setup.jumpToCell(cell.segId))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["nge-recap-cell-pip", {
                'nge-recap-cell-pip--done': cell.isComplete,
                'nge-recap-cell-pip--typed': !cell.isComplete && cell.cellType,
              }])
                          }, _toDisplayString(cell.isComplete ? '✓' : cell.cellType ? '🏷' : '○'), 3 /* TEXT, CLASS */),
                          _createElementVNode("span", _hoisted_47, _toDisplayString($setup.truncateId(cell.segId)), 1 /* TEXT */),
                          (cell.cellType)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(cell.cellType), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_46))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Scout and help activity this week "),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, _toDisplayString($setup.tagsPlacedThisWeek), 1 /* TEXT */),
                _hoisted_54
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, _toDisplayString($setup.tagsFixedThisWeek), 1 /* TEXT */),
                _hoisted_57
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, _toDisplayString($setup.helpAskedThisWeek), 1 /* TEXT */),
                _hoisted_60
              ]),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, _toDisplayString($setup.helpAnsweredThisWeek), 1 /* TEXT */),
                _hoisted_63
              ])
            ])
          ]),
          _createCommentVNode(" Community pulse "),
          ($setup.stats.communityEditsThisWeek > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, " 🌐 " + _toDisplayString($setup.stats.communityEditsThisWeek.toLocaleString()) + " edits by the EyeWire II community ", 1 /* TEXT */),
                ($setup.contributionPct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createTextVNode(" Your contribution: "),
                      _createElementVNode("strong", null, _toDisplayString($setup.contributionPct) + "%", 1 /* TEXT */),
                      _createTextVNode(" of this week's science ")
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Next badge progress "),
          ($setup.nextBadge)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _hoisted_69,
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, _toDisplayString($setup.nextBadge.name), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_72, _toDisplayString($setup.nextBadge.remaining.toLocaleString()) + " " + _toDisplayString($setup.nextBadge.track === 'building' ? 'edits' : 'cells') + " to go ", 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", {
                    class: "nge-recap-progress-fill",
                    style: _normalizeStyle({ width: $setup.nextBadge.progressPct + '%' })
                  }, null, 4 /* STYLE */)
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("span", null, _toDisplayString($setup.nextBadge.prevThreshold.toLocaleString()), 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.nextBadge.progressPct) + "%", 1 /* TEXT */),
                  _createElementVNode("span", null, _toDisplayString($setup.nextBadge.threshold.toLocaleString()), 1 /* TEXT */)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_78)),
          _createCommentVNode(" Science fun fact "),
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, _toDisplayString($setup.currentFact), 1 /* TEXT */)
          ])
        ])
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "class"]))
}